export type PreorderFormValidationInput = {
  isPreorderEnabled: boolean;
  preorderEta: string;
  preorderDepositValue: string;
  preorderCancellationFeeValue: string;
  preorderMaxQtyLbs: string;
};

export type PreorderFormValidationErrors = {
  preorderEta?: string;
  preorderDepositValue?: string;
  preorderCancellationFeeValue?: string;
  preorderMaxQtyLbs?: string;
};

export function shouldConfirmPreorderDisable(input: {
  previouslyEnabled: boolean;
  nextEnabled: boolean;
}): boolean {
  return input.previouslyEnabled === true && input.nextEnabled === false;
}

export function validatePreorderFormFields(
  input: PreorderFormValidationInput,
): PreorderFormValidationErrors {
  if (!input.isPreorderEnabled) return {};
  const errors: PreorderFormValidationErrors = {};
  if (!input.preorderEta) {
    errors.preorderEta = 'Next arrival date is required for pre-order products.';
  }
  if (input.preorderDepositValue === '') {
    errors.preorderDepositValue =
      'Deposit value is required when pre-order is enabled.';
  }
  if (input.preorderCancellationFeeValue === '') {
    errors.preorderCancellationFeeValue =
      'Cancellation fee value is required when pre-order is enabled.';
  }
  if (input.preorderMaxQtyLbs === '') {
    errors.preorderMaxQtyLbs =
      'Pre-order max quantity (lbs) is required when pre-order is enabled.';
  }
  return errors;
}
